<template>
  <div>
    <el-row style="text-align: left;margin-top: 20px;margin-left: 20px">
      <div style="font-size: 20px;font-weight: bold">{{title}}</div>
    </el-row>
    <el-row>
      <hr size=1 style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 20px"/>
    </el-row>
    <el-row  style="margin-top: 20px">
      <el-form  :model="filterForm.data" label-width="110px" class="search-condition" ref="filterRef">
        <el-row :span='20'>
          <el-col :span='8'  style="text-align: left;">
            <el-form-item label="专业:">
              {{specialty}}
            </el-form-item>
          </el-col>
          <el-col :span='8'  style="text-align: left;">
            <el-form-item label="项目:">
              {{project}}
            </el-form-item>
          </el-col>
          <el-col :span='8'  style="text-align: left;">
            <el-form-item label="图纸:">
              <el-select v-model="filterForm.data.drawing" @change="drawChange">
                <el-option
                  v-for="item in drawingList"
                  :key="item.id"
                  :label="item.drawingName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <hr size=1 style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 50px"/>
    </el-row>
    <el-row style="margin-top: 20px">
      <iframe :src="iframe_url" frameborder="0" style="width: 100%;height: 900px;" ></iframe>
    </el-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        title:'图纸信息',
        iframe_url:'',
        url:{
          draw:'/draw/drawing/list-by-profession'
        },
        specialty:'',
        project:'',
        projectID:'',
        taskID:'',
        drawingList:[],
        filterForm:{
          data:{
            drawing:''
          }
        },
      }
    },
    mounted(){
      document.querySelector('body').setAttribute('style', 'background-image:url()')
      /*this.iframe_url= '/static/web/viewer.html?file=/upload'+this.$route.query.path;*/
      this.taskID=this.$route.query.taskID;
      this.projectID=this.$route.query.projectID;
      this.project=decodeURI(this.$route.query.project);
      this.specialty=decodeURI(this.$route.query.profession);
      this.queryDrawing();
    },
    methods:{
      drawChange(data){
        var item = this.drawingList.find(function(obj) {return obj.id == data;});
        this.iframe_url = '/static/web/viewer.html?file=/upload'+item.blueprintPath;
      },
      queryDrawing(){
        this.$http.get(
          this.url.draw
          +"?projectId="+this.projectID
          +"&profession="+this.specialty
          ,
        ).then((res) => {
          if (res.body.status === 200) {
            this.drawingList = res.data.result;
          } else {
            this.$message.error('查询失败，请联系管理员');
          }
        },(error)=>{
          this.$message.error('查询失败，请联系管理员');
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/inspectDraw/business/reportExamine/drawing.vue